import styled, { css } from "styled-components";
import { breakpointRuleTablet } from "./variables";
export const FontFamilySpaceGrotesk = css `
    font-family: 'Space Grotesk', sans-serif;
`;
export const FontFamilyInter = css `
    font-family: 'Inter', sans-serif;
`;
export const HeadlinesH1 = styled.h1 `
    //styleName: Mobile/Headlines/H1 - 48pt Bold;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0;

    @media (${breakpointRuleTablet}) {
        //styleName: Desktop/Headlines/H1 - 64pt Bold;
        font-size: 64px;
        font-weight: 700;
        line-height: 68px;
        letter-spacing: -1px;
    }
`;
export const HeadlineH2 = styled.h2 `
    //styleName: Mobile/Headlines/H2 - 32pt Bold;
    ${FontFamilySpaceGrotesk};
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: -1px;

    @media (${breakpointRuleTablet}) {
        //styleName: Desktop/Headlines/H2 - 56pt Bold;
        font-size: 56px;
        line-height: 60px;

    }
`;
export const CssHeadlineH4 = css `
    //styleName: Mobile/Headlines/H4 - 28pt Bold;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.5px;

`;
export const CssHeadlineH4Desktop = css `
    //styleName: Desktop/Headlines/H4 - 32pt Bold;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: -1px;
`;
export const HeadlineH4 = styled.h4 `
    ${CssHeadlineH4};
    @media (${breakpointRuleTablet}) {
        ${CssHeadlineH4Desktop};
    }
`;
export const CssBodyXS = css `
    //styleName: Mobile/Body/Body XS - 14pt Regular;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
`;
export const CssBodyS = css `
    //styleName: Desktop/Body/Body S - 16pt Regular;
    ${FontFamilyInter};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0;
`;
export const BodyS = styled.p `
    ${CssBodyS};
`;
export const CssBodyM = css `
    //styleName: Desktop/Body/Body M- 18pt Regular;
    ${FontFamilyInter};
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0;
`;
export const BodyM = styled.p `
    ${CssBodyM};
`;
export const CssDetailRegular = css `
    //styleName: Desktop/Detail/Detail - 12pt Regular;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0;
`;
export const DetailRegular = styled.p `
    //styleName: Desktop/Detail/Detail - 12pt Regular;
    ${FontFamilyInter};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;

`;
export const CssDetailMedium = css `
    //styleName: Detail/D1 - 14pt Medium;
    ${FontFamilyInter};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
    text-align: right;
`;
export const DetailMedium = styled.p `
    ${CssDetailMedium};
`;
export const CssTitleL = css `
    //styleName: Mobile/Titles-Subtitles/Title L - 24pt Bold;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.5px;
`;
export const CssTitleL28 = css `
    //styleName: Desktop/Titles-Subtitles/Title L - 28pt Bold;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.5px;
`;
export const TitleL = styled.h3 `
    ${CssTitleL};
`;
export const CssTitleS = css `
    //styleName: Mobile/Titles-Subtitles/Title S - 16pt Bold;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;
`;
export const CssTitleM24 = css `
    //styleName: Desktop/Titles-Subtitles/Title M - 24pt Bold;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.5px;
`;
export const CssTitleM18 = css `
    //styleName: Mobile/Titles-Subtitles/Title M - 18pt Bold;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0;
`;
export const TitleM = styled.h3 `
    ${CssTitleM18};

    @media (${breakpointRuleTablet}) {
      ${CssTitleM24};
    }
`;
export const CssSubtitleM = css `
    //styleName: Mobile/Titles-Subtitles/Subtitle Label - 12 Medium -Uppercase;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 1px;
`;
export const CssTitlesS = css `
    //styleName: Desktop/Titles-Subtitles/Title S - 18pt Bold;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0;
`;
